import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

export const textWrapper = css`
  margin-bottom: 3rem;
  max-width: 42rem;
  text-align: center;
  overflow-wrap: anywhere;
`;

export const chevron = css`
  font-size: ${typography.captionFontSize};
  margin-right: 0.5rem;
`;
